import { AppColors } from '@cmbg-traky-web/design-system';
import { CSSProperties } from 'react';

type FiltersStyles = {
  advancedOverlay: CSSProperties;
  advancedRow: CSSProperties;
  advancedRowTight: CSSProperties;
  selectStores: CSSProperties;
  advancedActions: CSSProperties;
  button__clear: CSSProperties;
  button__search: CSSProperties;
  storeTag: CSSProperties;
  storeTagClose: CSSProperties;
  optionContainer: CSSProperties;
  optionContainerSelected: CSSProperties;
  optionCheckbox: CSSProperties;
  optionCheckboxSelected: CSSProperties;
  mobileDateRangeContainer: CSSProperties;
};

const styles: FiltersStyles = {
  advancedOverlay: {
    marginTop: '2rem',
    position: 'absolute',
    top: 'calc(52%)',
    left: 0,
    width: '100%',
    backgroundColor: AppColors.VA.NEUTRALS.WHITE,
    borderRadius: 8,
    border: `1px solid ${AppColors.VA.NEUTRALS._20_}`,
    boxShadow: '0 4px 12px rgba(0,0,0,0.12)',
    padding: '24px',
    zIndex: 1000,
    maxHeight: '60vh',
    overflowY: 'auto',
    WebkitOverflowScrolling: 'touch'
  },
  advancedRow: {
    display: 'flex',
    gap: '24px',
    flexWrap: 'wrap'
  },
  selectStores: {
    width: '100%'
  },
  advancedRowTight: {
    display: 'flex',
    gap: '12px',
    flexWrap: 'nowrap',
    marginBottom: '24px',
    paddingTop: '18px'
  },
  advancedActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '16px',
    width: '100%'
  },
  button__clear: {
    color: AppColors.VA.PRIMARY._50_,
    textDecoration: 'underline',
    height: '40px',
    fontWeight: '600'
  },
  button__search: {
    borderRadius: '8px',
    padding: '8px 16px',
    height: '40px',
    minWidth: '85px',
    color: AppColors.VA.NEUTRALS.WHITE,
    boxShadow: '0px 2px 0px 0px rgba(0, 0, 0, 0.043)'
  },
  storeTag: {
    display: 'inline-block',
    padding: '2px 8px',
    margin: '2px',
    backgroundColor: AppColors.VA.NEUTRALS._30_,
    border: AppColors.VA.NEUTRALS._40_,
    borderRadius: '4px',
    fontSize: '12px'
  },
  storeTagClose: {
    marginLeft: '4px',
    cursor: 'pointer',
    color: '#999'
  },
  optionContainer: {
    display: 'flex',
    alignItems: 'center',
    padding: '4px 0'
  },
  optionContainerSelected: {
    display: 'flex',
    alignItems: 'center',
    padding: '4px 0',
    backgroundColor: AppColors.VA.NEUTRALS._10_
  },
  optionCheckbox: {
    marginRight: 8,
    borderRadius: 2
  },
  optionCheckboxSelected: {
    marginRight: 8,
    borderRadius: 2,
    accentColor: AppColors.VA.NEUTRALS._10_
  },
  mobileDateRangeContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    width: '100%'
  }
};

export default styles;
